export default "__VITE_ASSET__scWo2PKp__";